import Header from 'components/headers/bulletins'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Switch from 'react-switch'
import { RootState } from 'store/redux'
import { toggleTransparency } from 'store/redux/moneyPoolBox'
export default function Transparency() {
    const store = useSelector((state: RootState) => state.MoneyPoolBoxAdd)
    const [checked, setChecked] = useState<{ [key: string]: boolean }>({
        showOtherRecieverLoans:
            store?.showOtherRecieverLoans !== undefined
                ? store?.showOtherRecieverLoans
                : true,
        showOtherWantedLoan:
            store?.showOtherWantedLoan !== undefined
                ? store?.showOtherWantedLoan
                : true,
        showOtherTransaction:
            store?.showOtherTransaction !== undefined
                ? store?.showOtherTransaction
                : true,
        showOverdue:
            store?.showOverdue !== undefined ? store?.showOverdue : true,
        showOthersData:
            store?.showOthersData !== undefined ? store?.showOthersData : true,
        showBalance:
            store?.showBalance !== undefined ? store?.showBalance : true,
        showDebt: store?.showDebt !== undefined ? store?.showDebt : true,
    })
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const handleChangeChecked = (value: string) => {
        const newChecked = { ...checked }
        newChecked[value] = !newChecked[value]
        setChecked(newChecked)
    }

    return (
        <div className="  flex flex-col bg-white h-full">
            <div className=" grow-0">
                <Header title="تنظیمات صندوق" />
            </div>
            <div className=" grow px-2">
                <p className=" text-lg my-2">مدیریت نمایش اطلاعات صندوق</p>
                <p className=" text-sm">
                    کدام یک از موارد زیر در صندوق به عضو عادی نمایش داده شود:
                </p>
                <hr className=" my-3" />
                <div className=" w-full flex justify-between my-2 px-2">
                    <p className=" text-lg">نمایش وام‌های اعطا شده به اعضا</p>
                    <Switch
                        onChange={() =>
                            handleChangeChecked('showOtherRecieverLoans')
                        }
                        checked={checked.showOtherRecieverLoans}
                        onColor="#75B844"
                        onHandleColor="#EAEEF0"
                        handleDiameter={25}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        height={30}
                        width={60}
                        className="react-switch"
                        id="material-switch"
                        offColor="#B6BCC8"
                    />
                </div>
                <p className=" my-3 px-2 text-sm">
                    با فعال کردن این گزینه، عضو عادی امکان مشاهده تمامی وام‌های
                    اعطا شده در صندوق را دارد.
                </p>
                <hr className=" my-2" />
                <div className=" w-full flex justify-between my-2 px-2">
                    <p className=" text-lg">نمایش وام‌های درخواستی اعضا</p>
                    <Switch
                        onChange={() =>
                            handleChangeChecked('showOtherWantedLoan')
                        }
                        checked={checked.showOtherWantedLoan}
                        onColor="#75B844"
                        onHandleColor="#EAEEF0"
                        handleDiameter={25}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        height={30}
                        width={60}
                        className="react-switch"
                        id="material-switch"
                        offColor="#B6BCC8"
                    />
                </div>
                <p className=" my-3 px-2 text-sm">
                    با فعال کردن این گزینه، عضو عادی امکان مشاهده تمامی وام‌های
                    درخواستی در صندوق را دارد.
                </p>
                <hr className=" my-2" />
                <div className=" w-full flex justify-between my-2 px-2">
                    <p className=" text-lg">نمایش تراکنش‌های صندوق</p>
                    <Switch
                        onChange={() =>
                            handleChangeChecked('showOtherTransaction')
                        }
                        checked={checked.showOtherTransaction}
                        onColor="#75B844"
                        onHandleColor="#EAEEF0"
                        handleDiameter={25}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        height={30}
                        width={60}
                        className="react-switch"
                        id="material-switch"
                        offColor="#B6BCC8"
                    />
                </div>
                <p className=" my-3 px-2 text-sm">
                    ‌با فعال کردن این گزینه، عضو عادی امکان مشاهده تمامی تراکنش‌های
                     انجام شده در صندوق را دارد.
                </p>
                <hr className=" my-2" />
                <div className=" w-full flex justify-between my-2 px-2">
                    <p className=" text-lg">
                        نمایش معوقات وام اعضا (لیبل معوق)
                    </p>
                    <Switch
                        onChange={() => handleChangeChecked('showOverdue')}
                        checked={checked.showOverdue}
                        onColor="#75B844"
                        onHandleColor="#EAEEF0"
                        handleDiameter={25}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        height={30}
                        width={60}
                        className="react-switch"
                        id="material-switch"
                        offColor="#B6BCC8"
                    />
                </div>
                <p className=" my-3 px-2 text-sm">
                    با فعال کردن این گزینه، عضو عادی امکان مشاهده تمامی اقساط
                    معوق سایر اعضا در صندوق را دارد.
                </p>
                <hr className=" my-2" />
                <div className=" w-full flex justify-between my-2 px-2">
                    <p className=" text-lg">
                        نمایش اطلاعات کلی اعضای صندوق
                    </p>
                    <Switch
                        onChange={() => handleChangeChecked('showOthersData')}
                        checked={checked.showOthersData}
                        onColor="#75B844"
                        onHandleColor="#EAEEF0"
                        handleDiameter={25}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        height={30}
                        width={60}
                        className="react-switch"
                        id="material-switch"
                        offColor="#B6BCC8"
                    />
                </div>
                <p className=" my-3 px-2 text-sm">
                    با فعال کردن این گزینه، عضو عادی امکان مشاهده اسامی تمامی
                    اعضای صندوق را دارد.
                </p>
                <hr className=" my-2" />
                <div className=" w-full flex justify-between my-2 px-2">
                    <p className=" text-lg">نمایش موجودی صندوق</p>
                    <Switch
                        onChange={() => handleChangeChecked('showBalance')}
                        checked={checked.showBalance}
                        onColor="#75B844"
                        onHandleColor="#EAEEF0"
                        handleDiameter={25}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        height={30}
                        width={60}
                        className="react-switch"
                        id="material-switch"
                        offColor="#B6BCC8"
                    />
                </div>
                <p className=" my-3 px-2 text-sm">
                    با فعال کردن این گزینه، عضو عادی امکان مشاهده موجودی صندوق
                    را دارد.
                </p>
                <hr className=" my-2" />
                <div className=" w-full flex justify-between my-2 px-2">
                    <p className=" text-lg">
                        نمایش میزان بدهی حق‌عضویت اعضا
                    </p>
                    <Switch
                        onChange={() => handleChangeChecked('showDebt')}
                        checked={checked.showDebt}
                        onColor="#75B844"
                        onHandleColor="#EAEEF0"
                        handleDiameter={25}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        height={30}
                        width={60}
                        className="react-switch"
                        id="material-switch"
                        offColor="#B6BCC8"
                    />
                </div>
                <p className=" my-3 px-2 text-sm">
                    با فعال کردن این گزینه، عضو عادی امکان مشاهده بدهکاری حق‌عضویت
                     اعضای صندوق را دارد.
                </p>
            </div>
            <div className=" grow-0">
                <div className=" bg-white py-4 px-4">
                    <button
                        className=" w-full bg-green-1 rounded-2xl text-white py-3"
                        onClick={() => {
                            dispatch(
                                toggleTransparency({
                                    showOtherRecieverLoans:
                                        checked.showOtherRecieverLoans,
                                    showOtherWantedLoan:
                                        checked.showOtherWantedLoan,
                                    showOtherTransaction:
                                        checked.showOtherTransaction,
                                    showOverdue: checked.showOverdue,
                                    showOthersData: checked.showOthersData,
                                    showBalance: checked.showBalance,
                                    showDebt: checked.showDebt,
                                })
                            )
                            navigate(-1)
                        }}
                    >
                        ثبت تغییرات
                    </button>
                </div>
            </div>
        </div>
    )
}
